import RelinkDialog from './RelinkDialog';

export default RelinkDialog;
